import React, { useRef, useEffect, useState, useContext } from "react";
import { useSelector } from "react-redux";
import { jsonEditorContext } from "../../../Context/jsonEditorContext";
import ResumeSubUseForm from "../../../hooks/editor/resumeSubUseForm";
import { useTranslation } from "react-i18next";
import ChangeResumeOrder from "../../../hooks/editor/changeResumeOrder";
import ContentEditable from "../../../Components/ContentEditable/ContentEditable";
import SectionItemToolbar from "../../../Components/GlobalSectionToolbar/SectionItemToolbar";
import Slider from "../../../Components/RcSlider/rcSlider";
import { FontIncrease } from "../../../Utils/FontIncrease";
import SectionHeader from "../SectionHeader/sectionHeader";
import SectionItemWrapper from "../SectionItemWrapper/SectionItemWrapper";
import PieChart from "../../../Components/GraphsAndCharts/Language/PieChart/PieChart";
import DoubleCircle from "../../../Components/GraphsAndCharts/Language/DoubleCircle/doubleCircle";
import PieCircle from "../../../Components/GraphsAndCharts/Language/PieCircleNew/PieCircle";
import SplitSlider from "../../../Components/GraphsAndCharts/Language/SplitSlider/SplitSlider";
function Languages(props) {
  const {
    resumeFields,
    sectionId,
    resumeTitleHandler,
    handleEditorChange,
    resumeHandler,
    resumeUpdate,
    dateHandler,
    languageHandler,
    styles,
    settings,
    handleSliderChange,
    PageMargin,
    SectionMargin,
    handleLanguageSliderChange,
    layout,
  } = props;
  const { selectedFont, primaryColor, secondaryColor, titleFont, bodyFont } =
    styles;
  const [t, i18n] = useTranslation("common");
  const { json, setJson, jsonIndex, setJsonIndex, isJson, setIsJson } =
    useContext(jsonEditorContext);

  const [focusIndex, setFocusIndex] = useState(false);
  const [showDatePicker, setShowDatePicker] = useState(false);

  //UseForm

  const {
    addResumeField,
    handleDelete,
    handleShowSection,
    handleOnDragEnd,
    // sectionTitleUpdate,
    sectionItemMoveUp,
    sectionItemMoveDown,
    sectionPageLayoutUpdate,
    showHideElements,
  } = ResumeSubUseForm(props.sectionId);

  const innerSectionClick = (e, index) => {
    props.changeFocusStyle(props.sectionId, index.toString(), "item");
  };

  const editorSettings = useSelector(
    (state) => state.editorData.editorSettings
  );
  useEffect(() => {
    setFocusIndex(false);
  }, []);

  return (
    <>
      {resumeFields && resumeFields.show && (
        <>
          <SectionHeader
            styles={styles}
            settings={settings}
            resumeFields={resumeFields}
            sectionId={sectionId}
            resumeTitleHandler={resumeTitleHandler}
            resumeUpdate={resumeUpdate}
            PageMargin={PageMargin}
            SectionMargin={SectionMargin}
          />
          <div className="section-item-wrapper languages-item-wrapper">
            {props &&
              props.response &&
              props.response.itemIndexes.map(
                (result, ind) =>
                  resumeFields &&
                  resumeFields.data &&
                  resumeFields.data.map((response, index, row) =>
                    index == result ? (
                      <SectionItemWrapper
                        sectionId={sectionId}
                        styles={styles}
                        layout={layout}
                        index={index}
                        newSectionFocus={props.newSectionFocus}
                        currentStateFocus={props.currentStateFocus}
                        newItemFocus={props.newItemFocus}
                        SectionMargin={SectionMargin}
                        isFixedPaddingBottom={true}
                        paddingBottom={"5px"}
                        onMouseDown={(e) => e.stopPropagation()}
                        onClick={(e) => {
                          e.stopPropagation();
                          innerSectionClick(e, index);
                        }}
                      >
                        {props.newSectionFocus == props.sectionId &&
                          props.currentStateFocus == "item" &&
                          props.newItemFocus &&
                          props.newItemFocus == index.toString() && (
                            <SectionItemToolbar
                              index={index}
                              indexString={index.toString()}
                              handleDelete={props.handleItemDelete}
                              addAdditionalField={props.addAdditionalField}
                              sectionItemMoveUp={props.sectionItemMoveUp}
                              sectionItemMoveDown={props.sectionItemMoveDown}
                              row={row}
                              sectionId={props.sectionId}
                              startFrom={response.startFrom}
                              endUntil={response.endUntil}
                              resumeUpdate={resumeUpdate}
                              dateHandler={dateHandler}
                              showDatePicker={showDatePicker}
                              response={response}
                              changeSettings={props.changeSettings}
                              handleSliderChange={handleSliderChange}
                              languageHandler={languageHandler}
                              handleLanguageSliderChange={
                                handleLanguageSliderChange
                              }
                            />
                          )}

                        {/* {response.showFields.proficiencyText && (
                          <p
                            className="m-0"
                            style={{
                              fontFamily: styles.bodyFont,
                              color: styles.bodyFontColor,
                              minWidth: "26.49px",
                              fontSize: styles?.common?.fontSmallSize,
                            }}
                          >
                            {response.level}
                          </p>
                        )} */}
                        {response &&
                          response.showFields &&
                          response.showFields.slider && (
                            <div className=" p-0 align-self-center">
                              {/* <Slider
                              response={response}
                              sectionId={"languages"}
                              index={index}
                              primaryColor={styles.primaryColor}
                              languageHandler={languageHandler}
                              resumeUpdate={resumeUpdate}
                            /> */}
                              {/* <PieChart
                                color={styles.secondaryColor}
                                value={response?.level}
                              /> */}
                              {editorSettings?.languages?.indicatorType == 1 ? (
                                <div className=" p-0 align-self-center">
                                  <SplitSlider
                                    color={styles.secondaryColor}
                                    value={response?.level}
                                    bgColor={styles?.bgColor?.bgColor}
                                  />
                                </div>
                              ) : editorSettings?.languages?.indicatorType ==
                                2 ? (
                                <div className=" p-0 align-self-center">
                                  <PieChart
                                    color={styles.secondaryColor}
                                    value={response?.level}
                                  />
                                </div>
                              ) : editorSettings?.languages?.indicatorType ==
                                3 ? (
                                <div className=" p-0 align-self-center">
                                  <DoubleCircle
                                    color={styles.secondaryColor}
                                    value={response?.level}
                                    bgColor={styles?.bgColor?.bgColor}
                                  />
                                </div>
                              ) : editorSettings?.languages?.indicatorType ==
                                4 ? (
                                <div className=" p-0 align-self-center">
                                  <PieCircle
                                    color={styles.secondaryColor}
                                    value={response?.level}
                                    bgColor={styles?.bgColor?.bgColor}
                                  />
                                </div>
                              ) : (
                                <div className=" p-0 align-self-center">
                                  <PieCircle
                                    color={styles.secondaryColor}
                                    value={response?.level}
                                    bgColor={styles?.bgColor?.bgColor}
                                  />
                                </div>
                              )}
                            </div>
                          )}
                        {response &&
                          response.showFields &&
                          response.showFields.name && (
                            <div
                              className=""
                              style={{ width: "80px", textAlign: "center" }}
                            >
                              <ContentEditable
                                sectionId={sectionId}
                                name="name"
                                tagType="div"
                                className=" m-0"
                                index={index}
                                value={response.name}
                                placeholder="Language"
                                onChange={resumeHandler}
                                onBlur={resumeUpdate}
                                style={{
                                  fontFamily: bodyFont,
                                  color: styles.primaryColor,
                                  minWidth: "26.49px",
                                  fontSize: selectedFont?.tool,
                                  lineHeight: selectedFont?.tool_lineHeight,
                                }}
                              />
                            </div>
                          )}
                      </SectionItemWrapper>
                    ) : (
                      ""
                    )
                  )
              )}
          </div>
        </>
      )}
    </>
  );
}

export default Languages;
